"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integracionPlexoConverter = void 0;
exports.integracionPlexoConverter = {
    toFirestore(obj) {
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            habilitada: data.habilitada,
            visa: data.visa,
            master: data.master,
            oca: data.oca,
            bbva: data.bbva,
            brou: data.brou,
            hsbc: data.hsbc,
            itau: data.itau,
            santander: data.santander,
            scotiabank: data.scotiabank,
            heritage: data.heritage,
            bandes: data.bandes,
        };
    }
};
